import { Box } from '@chakra-ui/react';
import UsersPanel from './UsersPanel';
import Footer from '../../../../../components/Footer';

const Users = () => {
  return (
    <Box height="100%" id="scrollable-wrapper">
      <Box minHeight="100%" padding={5}>
        <UsersPanel />
      </Box>
      <Footer />
    </Box>
  );
};

export default Users;
